import React from "react";
import ContactBanner from "../bannners/contactBanner";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";

function Contact({ sliderContact, globalData }) {
  return (
    <div className="et-boc">
      <Header />
      <div id="et-main-area">
        <div id="main-content">
          <ContactBanner sliderContact={sliderContact} globalData={globalData} />
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Contact;
